import { isDev } from './env.js';
import jsonp from 'jsonp';
import baseInfo, { ztInitInfo } from '@stores/index.js';
import logger from '@server-utils/client-logger';

function gamematch_log() {
    if (window.location.search.indexOf('log=true') >= 0) {
        logger.info({ ...arguments });
    }
}

export { gamematch_log };

function creatUuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getUuid() {
    let uuid = 0;
    if (window && window.localStorage) {
        if (window.localStorage.errorWatchKey) {
            uuid = window.localStorage.errorWatchKey;
        } else {
            uuid = creatUuid().toLowerCase();
            window.localStorage.setItem('errorWatchKey', uuid);
        }
    }
    return uuid;
}

const setLog = {
    getFormatedDate: function(date) {
        let YY = date.getFullYear(),
            MM = date.getMonth() + 1,
            dd = date.getDate(),
            hh = date.getHours(),
            mm = date.getMinutes(),
            ss = date.getSeconds();
        MM = MM < 10 ? '0' + MM : MM;
        dd = dd < 10 ? '0' + dd : dd;
        hh = hh < 10 ? '0' + hh : hh;
        mm = mm < 10 ? '0' + mm : mm;
        ss = ss < 10 ? '0' + ss : ss;
        return YY + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss;
    },
    handleInfo: function(info) {
        let obj = [],
            txt = '',
            that = this;
        let infoObj = Object.assign(
            {
                id: ztInitInfo.ztConfig.domain,
                name: ztInitInfo.ztConfig.name,
                game_type: ztInitInfo.ztConfig.gametype,
                current_url: window.location.href
            },
            info.info
        );
        obj.push(['id', info.id]);
        obj.push(['time', that.getFormatedDate(new Date())]);
        obj.push(['a_aid', info.uid || baseInfo.userInfo ? baseInfo.userInfo.uid : '-2']);
        obj.push(['uuid', info.uuid || getUuid() || '-2']);
        obj.push(['udid', info.udid || '-2']);
        obj.push(['client_type', info.client_type || '-2']);
        obj.push([
            'r_aid',
            info.anchorid || baseInfo.anchorInfo ? baseInfo.anchorInfo.anchorId : '-2'
        ]);
        obj.push(['template1', '-2']);
        obj.push([
            'room1_id',
            info.roomid || baseInfo.anchorInfo ? baseInfo.anchorInfo.roomId : '-2'
        ]);
        obj.push([
            'sub1_id',
            info.subcId || baseInfo.anchorInfo ? baseInfo.anchorInfo.subcId : '-2'
        ]);
        obj.push(['template2', '-2']);
        obj.push(['room2_id', info.room2id || '-2']);
        obj.push(['sub2_id', info.sub2id || '-2']);
        obj.push(['ip', info.ip || '-2']);
        obj.push([
            'info',
            infoObj ? (typeof infoObj === 'string' ? infoObj : JSON.stringify(infoObj)) : '-2'
        ]);
        for (var i = 0; i < obj.length; i++) {
            txt += obj[i][0] + '=' + obj[i][1] + ',,';
        }
        txt = txt.substr(0, txt.length - 2);
        return txt;
    },
    set: function(info) {
        //try {
        let url = isDev ? '//userlog.dev.cc.163.com' : '//userlog.cc.netease.com';
        url += '/query';
        info = this.handleInfo(info);
        gamematch_log(decodeURIComponent(info));
        info = window.btoa(encodeURIComponent(info));
        jsonp(url + '?type=web&data=' + info, {}, (err, data) => {
            if (err) {
                gamematch_log(err);
            } else {
                gamematch_log(data);
            }
        });
        // }catch(e) {
        //     gamematch_log(e);
        // }
    }
};
export default setLog;
